/* eslint-disable array-callback-return */
import {Trans} from '@lingui/macro';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  lighten,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
  withStyles,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from '@material-ui/core/styles';
import {
  ChevronLeftOutlined,
  ChevronRightOutlined,
  Clear,
  DoneOutline,
  Dvr,
  KeyboardArrowRight,
} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';
import SignatureDialog from '../../../components/Editors/SignatureDialog';
import {putIntoArrayAt} from '../../../helpers/functions.js';
import * as hooks from '../hookos/hooks';
import {TABLETCOURSE} from './actions';
import Multibox from './choice/multiplebox';
import Singlebox from './choice/simplebox';
import {ContentStatus, ContentTypes, TestFailed, TestPassed} from './Online';
import {i18n2} from 'features/i18n/i18n';
import {REMOVE_NOTIFICATION} from 'features/navigation/actions';

const useStyles = makeStyles((theme) => ({
  grid: {
    flexGrow: 1,
  },
  container: {
    margin: '2vh',
  },
  questionContainer: {
    textAlign: 'left',
    margin: 'auto',
    padding: theme.spacing(4),
    maxWidth: '800px',
    width: '90%',
    minHeight: 'auto',
    maxHeight: 'none',
  },
  questionText: {
    fontSize: '1.2rem',
    fontWeight: 500,
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    marginBottom: theme.spacing(3),
  },
  answerOption: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '12px',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      boxShadow: theme.shadows[1],
    },
  },
  nextButtonContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
  },
  nextButton: {
    padding: theme.spacing(2, 6),
    fontWeight: 600,
  },
}));

const BorderLinearProgress = withStyles({
  root: {
    margin: '2vh',
    height: 10,
    backgroundColor: lighten('#496778', 0.5),
  },
  bar: {
    borderRadius: 20,
    backgroundColor: '#496778',
  },
})(LinearProgress);

const ChoiceTypes = {
  Single: 0,
  Choice: 1,
};

const ChoicePresentation = ({content, onInit, number}) => {
  return (
    <div
      style={{
        padding: '20px',
        maxWidth: '100%',
        overflowX: 'hidden',
        wordBreak: 'break-word',
        textAlign: 'center',
      }}>
      <Typography variant="subtitle1">
        <Trans>Cuestionario N°</Trans> {number}
      </Typography>

      <Typography
        variant="h2"
        style={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'normal',
          maxWidth: '90%',
          margin: '0 auto',
        }}>
        {content.title}
      </Typography>

      <Typography
        variant="h6"
        style={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'normal',
          maxWidth: '90%',
          margin: '10px auto',
        }}>
        {content.description}
      </Typography>

      <Divider />

      <Button
        variant="contained"
        color="primary"
        style={{marginTop: '2vh'}}
        onClick={() => onInit()}>
        <Trans>Iniciar</Trans>
      </Button>
    </div>
  );
};

const TabletTestPresentation = ({onInit, isEmpty}) => {
  return (
    <div style={{padding: '20px'}}>
      <Typography variant="h2">
        <Trans>Curso de capacitación</Trans>
      </Typography>
      <Typography variant="h6">
        <Trans>Versión tablet</Trans>
      </Typography>
      {isEmpty ? (
        <Typography variant="subtitle1">
          <Trans>- Curso sin contenidos -</Trans>
        </Typography>
      ) : (
        <></>
      )}
      <Divider />
      <Button
        variant="contained"
        color="primary"
        style={{marginTop: '2vh'}}
        onClick={() => onInit()}>
        {!isEmpty ? 'Iniciar' : 'Firmar'}
      </Button>
    </div>
  );
};

const StepButtons = ({changeStep, index, max, atEnding}) => {
  let isLast = index + 1 === max;
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Button
        color="primary"
        onClick={() => changeStep(-1)}
        disabled={index === 0}
        startIcon={<ChevronLeftOutlined />}
        style={{padding: '12px 24px', margin: '4px'}}>
        <Trans>Anterior</Trans>
      </Button>
      <Button
        color="primary"
        onClick={() => (!isLast ? changeStep(1) : atEnding.action())}
        endIcon={!isLast ? <ChevronRightOutlined /> : <Dvr />}
        disabled={isLast && atEnding.disabled}
        style={{padding: '12px 24px', margin: '4px'}}>
        {!isLast ? 'Siguiente' : atEnding.button}
      </Button>
    </Box>
  );
};

const Tablet = (props) => {
  const classes = useStyles();
  const [contents, setContents] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [courseFinished, setCourseFinished] = useState({
    open: false,
    score: 0,
    approved: false,
    message: '',
  });
  const [activeContent, setActiveContent] = useState(0);
  const [activeChoice, setActiveChoice] = useState(0);
  const [isTestStarted, setIsTestStarted] = useState(false);
  const [status, setStatus] = useState(0);
  const [numberOfQuestions, setNumberOfQuestions] = useState(0);
  const [correct, setCorrect] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [employee_Nr, setEmployeen_Nr] = useState();
  const [popupFinish, setPopupFinish] = useState(false);
  // const [score, setScore] = useState(0);
  const tablet = props.data.tablet ? true : false;
  // const [activeStep, setActiveStep] = React.useState(0);
  const [doneStatus, setDoneStatus] = React.useState([]);
  const [doneProgress, setDoneProgress] = React.useState([]);
  // const [contentScores, setContentScores] = React.useState();
  const [showContentList, setShowContentList] = React.useState(false);
  const [initCourse, setInitCourse] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [poupOut, setPopupOut] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let contents = [];
    let helper = 0;
    if (tablet) {
      let status = 0;
      let choiceIndex = 0;
      let contentStart = -1; // If undone or failed content is found, test should start there. Else, by default, it starts on content 0.
      let doneContents = [];
      hooks
        .getCourseContents(
          props.data.iD_Course,
          props.data.iD_Instance,
          props.data.cwid,
          props.data.token,
        )
        .then((data) => {
          let helper = 0;
          let contents = [];
          data.map((item) => {
            if (
              item.type === ContentTypes.Choice &&
              item.choices.filter((x) => x.length > 0)
            ) {
              helper = helper + item.choices.length;
              contents.push(item);
              status += item.approved ? item.choices.length : 0;
              doneContents.push(item.approved !== ContentStatus.Undone);
              if (
                contentStart === -1 &&
                item.approved !== ContentStatus.DoneApproved
              ) {
                contentStart = choiceIndex;
              }
              choiceIndex++;
            }
          });
          setStatus(status);
          setNumberOfQuestions(helper);
          setContents(contents);
          let contentStatuses = data.reduce(
            (acc, content) =>
              content.type === ContentTypes.Choice
                ? acc.concat({status: content.approved, score: content.score})
                : acc,
            [],
          );
          setDoneStatus(contentStatuses);
          setDoneProgress(doneContents);
          setActiveContent(contentStart === -1 ? 0 : contentStart);
          setLoading(false);
        });
      dispatch({type: TABLETCOURSE, payload: {tablet: true, assistants: true}});
    } else {
      contents.push(props.data.content);
      helper = props.data.content.choices.length;
      setNumberOfQuestions(helper);
      setContents(contents);
      setLoading(false);
    }
    return () => {
      if (tablet) {
        dispatch({
          type: TABLETCOURSE,
          payload: {tablet: false, assistants: true},
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startTest = () => {
    hooks
      .initContent(
        props.data.iD_Course,
        contents[activeContent].iD_Content,
        props.data.iD_Instance,
        props.data.cwid,
        2,
        props.data.token,
      )
      .then((response) => {
        response.json().then((data) => {
          setAttempt(data.attempt);
          setEmployeen_Nr(data.employee_Nr);
        });
      });
    setIsTestStarted(true);
  };

  const nextQuestion = () => {
    if (tablet) {
      nextQuestionTablet();
    } else {
      nextQuestionOnline();
    }
  };
  //funcion test para tablet
  const nextQuestionTablet = () => {
    setCorrect(false);
    hooks
      .saveResult(
        props.data.iD_Course,
        contents[activeContent].iD_Content,
        props.data.iD_Instance,
        employee_Nr,
        attempt,
        contents[activeContent].choices[activeChoice].iD_Choice,
        correct,
        props.data.token,
      )
      .then((response) => {
        if (contents[activeContent].choices.length > activeChoice + 1) {
          //active choice era pregunta actual
          if (contents.length >= activeContent + 1) {
            // Cambia el choice actual por el siguiente
            setActiveChoice(activeChoice + 1);
            setStatus(status + 1);
          }
          // Si ya terminé con los choices del content actual, cambio de content, choice le pongo index 0,
          // vuelvo al botón de "está por empezar tal curso" y cambio el status (status sirve para que la barrita de progreso avance)
        } else if (contents.length > activeContent + 1) {
          hooks
            .updateContent(
              props.data.iD_Course,
              contents[activeContent].iD_Content,
              props.data.iD_Instance,
              employee_Nr,
              attempt,
              props.data.token,
            )
            .then((response) => {
              if (response.ok) {
                setActiveChoice(0);
                setStatus(status + 1);
                response.json().then((contentResult) => {
                  setDoneStatus(
                    putIntoArrayAt(
                      {
                        status: contentResult.approved
                          ? ContentStatus.DoneApproved
                          : ContentStatus.DoneFailed,
                        score: contentResult.contentScore,
                      },
                      doneStatus,
                      activeContent,
                    ),
                  );
                  if (contentResult.approved) {
                    setDoneProgress(
                      putIntoArrayAt(true, doneProgress, activeContent),
                    );
                  }
                });
              }
            });
        } else {
          setStatus(status + 1);
          setActiveChoice(0);
          hooks
            .updateContent(
              props.data.iD_Course,
              contents[activeContent].iD_Content,
              props.data.iD_Instance,
              employee_Nr,
              attempt,
              props.data.token,
            )
            .then((response) => {
              response.json().then((contentResult) => {
                setDoneStatus(
                  putIntoArrayAt(
                    {
                      status: contentResult.approved
                        ? ContentStatus.DoneApproved
                        : ContentStatus.DoneFailed,
                      score: contentResult.contentScore,
                    },
                    doneStatus,
                    activeContent,
                  ),
                );
                if (contentResult.approved) {
                  setDoneProgress(
                    putIntoArrayAt(true, doneProgress, activeContent),
                  );
                }
              });
            });
        }
      });
  };

  // Debo resetear del progreso (status) aquella cantidad de preguntas que contesto hasta ahora, antes de cambiar de content
  const moveContent = (step) => {
    setStatus(status - activeChoice);
    setActiveChoice(0);
    setIsTestStarted(false);
    setActiveContent(activeContent + step);
  };

  const nextQuestionOnline = () => {
    setCorrect(false);
    hooks
      .saveResult(
        props.data.iD_Course,
        contents[activeContent].iD_Content,
        props.data.iD_Instance,
        employee_Nr,
        attempt,
        contents[activeContent].choices[activeChoice].iD_Choice,
        correct,
        props.data.token,
      )
      .then((response) => {
        if (contents[activeContent].choices.length > activeChoice + 1) {
          //active choice era pregunta actual
          if (contents.length >= activeContent + 1) {
            // Cambia el choice actual por el siguiente
            setActiveChoice(activeChoice + 1);
            setStatus(status + 1);
          }
          // Si ya terminé con los choices del content actual, cambio de content, choice le pongo index 0,
          // vuelvo al botón de "está por empezar tal curso" y cambio el status (status sirve para que la barrita de progreso avance)
        } else if (contents.length > activeContent + 1) {
          hooks
            .updateContent(
              props.data.iD_Course,
              contents[activeContent].iD_Content,
              props.data.iD_Instance,
              employee_Nr,
              attempt,
              props.data.token,
            )
            .then((response) => {
              setActiveChoice(0);
              setIsTestStarted(false);
              setActiveContent(activeContent + 1);
              setStatus(status + 1);
            });
        } else {
          setStatus(status + 1);
          hooks
            .updateContent(
              props.data.iD_Course,
              contents[activeContent].iD_Content,
              props.data.iD_Instance,
              employee_Nr,
              attempt,
              props.data.token,
            )
            .then((response) => {
              response
                .json()
                .then((contentResult) => {
                  if (contentResult.approved) {
                    props.approved(contentResult.contentScore * 100);
                  } else {
                    props.failed(contentResult.contentScore);
                  }
                })
                .catch((error) =>
                  console.error(
                    'Error on JSON deserealize from /UpdateContent',
                    error,
                  ),
                );
            });
        }
      });
  };

  const submit = (values, resetForm) => {
    hooks
      .updateAttempt(
        props.data.iD_Course,
        props.data.iD_Instance,
        props.data.cwid,
        values.pass,
        props.data.token,
      )
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setCourseFinished({
              open: true,
              score: data * 100,
              approved: true,
              message: `${i18n2._('Curso terminado con puntaje')} ${
                data * 100
              }%`,
            });
          });
        } else {
          response.text().then((respMessage) => {
            setCourseFinished({
              open: true,
              score: 0,
              approved: false,
              message: respMessage,
            });
            resetForm();
          });
        }
      });
  };

  return (
    <>
      {typeof props.data === 'undefined' ||
      typeof props.data.iD_Course === 'undefined' ||
      redirect ? (
        <Redirect
          to={{
            pathname: '/TabletCourse',
            state: {
              data: {
                iD_Instance: props.data.iD_Instance,
                iD_Course: props.data.iD_Course,
              },
            },
          }}
        />
      ) : loading ? (
        <CircularProgress />
      ) : (
        <>
          <Box
            justifyContent="center"
            style={{textAlign: 'center', margin: '0 auto'}}>
            <Paper
              elevation={3}
              style={{
                height: '90vh',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
              }}>
              <Box
                style={{
                  flex: 1,
                  minHeight: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: initCourse ? 'flex-start' : 'center',
                  padding: '16px',
                }}>
                {!initCourse && tablet ? (
                  <TabletTestPresentation
                    onInit={() =>
                      contents.length > 0
                        ? setInitCourse(true)
                        : setPopupFinish(true)
                    }
                    isEmpty={doneStatus.length === 0}
                  />
                ) : showContentList && tablet ? (
                  <div>
                    <List>
                      {contents.map((content, index) => {
                        return (
                          <ListItem
                            button
                            onClick={() => {
                              setActiveChoice(0);
                              setShowContentList(!showContentList);
                              setStatus(status - activeChoice); // Debo resetear del progreso (status) aquella cantidad de preguntas que contesto hasta ahora, antes de cambiar de content
                              setActiveContent(index);
                            }}
                            selected={index === activeContent}
                            disabled={doneProgress
                              .slice(0, index)
                              .includes(false)}>
                            <ListItemAvatar>
                              <Avatar>
                                {doneStatus[index].status ===
                                ContentStatus.DoneApproved ? (
                                  <DoneOutline />
                                ) : doneStatus[index].status ===
                                  ContentStatus.DoneFailed ? (
                                  <Clear />
                                ) : (
                                  <KeyboardArrowRight />
                                )}
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={content.title}
                              secondary={content.description}
                            />
                          </ListItem>
                        );
                      })}
                      <ListItem
                        button
                        // disabled={doneStatus.includes(ContentStatus.DoneFailed) || doneStatus.includes(ContentStatus.Undone)}
                        disabled={
                          doneStatus.filter(
                            (done) =>
                              done.status === ContentStatus.DoneFailed ||
                              done.status === ContentStatus.Undone,
                          ).length > 0
                        }
                        onClick={() => setPopupFinish(true)}>
                        <ListItemAvatar>
                          <Avatar>
                            <Dvr />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={i18n2._('Firma')}
                          secondary={i18n2._('Confirmación del curso')}
                        />
                      </ListItem>
                    </List>
                  </div>
                ) : (
                  <>
                    <BorderLinearProgress
                      className={classes.margin}
                      variant="determinate"
                      color="primary"
                      value={(status / numberOfQuestions) * 100}
                    />
                    {tablet &&
                    doneStatus.length > 0 &&
                    doneStatus[activeContent].status ===
                      ContentStatus.DoneApproved ? (
                      <>
                        <TestPassed
                          score={doneStatus[activeContent].score * 100}
                          onReset={() => {
                            setDoneStatus(
                              putIntoArrayAt(
                                {
                                  status: ContentStatus.Undone,
                                  score: 0,
                                },
                                doneStatus,
                                activeContent,
                              ),
                            );
                            setActiveChoice(0);
                            setIsTestStarted(false);
                            setStatus(
                              status - contents[activeContent].choices.length,
                            );
                          }}
                        />
                      </>
                    ) : tablet &&
                      doneStatus.length > 0 &&
                      doneStatus[activeContent].status ===
                        ContentStatus.DoneFailed ? (
                      <>
                        <TestFailed
                          score={doneStatus[activeContent].score * 100}
                          onReset={() => {
                            setDoneStatus(
                              putIntoArrayAt(
                                {
                                  status: ContentStatus.Undone,
                                  score: 0,
                                },
                                doneStatus,
                                activeContent,
                              ),
                            );
                            setActiveChoice(0);
                            setIsTestStarted(false);
                            setStatus(
                              status - contents[activeContent].choices.length,
                            );
                          }}
                        />
                      </>
                    ) : !isTestStarted ? (
                      <ChoicePresentation
                        content={contents[activeContent]}
                        onInit={startTest}
                        number={activeContent + 1}
                      />
                    ) : (
                      <Grid
                        container
                        className={classes.questionContainer}
                        style={{
                          flex: 1,
                          minHeight: 0,
                          overflowY: 'auto',
                        }}>
                        {' '}
                        <Grid item xs={12}>
                          <Typography
                            variant="h4"
                            className={classes.questionText}>
                            {
                              contents[activeContent].choices[activeChoice]
                                .question
                            }
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          {contents[activeContent].choices[activeChoice]
                            .type === ChoiceTypes.Single ? (
                            <Singlebox
                              data={
                                contents[activeContent].choices[activeChoice]
                              }
                              setCorrect={setCorrect}
                              className={classes.answerOption}
                            />
                          ) : contents[activeContent].choices[activeChoice]
                              .type === ChoiceTypes.Choice ? (
                            <Multibox
                              data={
                                contents[activeContent].choices[activeChoice]
                              }
                              setCorrect={setCorrect}
                              className={classes.answerOption}
                            />
                          ) : (
                            ''
                          )}
                          <div className={classes.nextButtonContainer}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => nextQuestion()}
                              className={classes.nextButton}>
                              <Trans>Siguiente</Trans>
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    )}
                  </>
                )}
              </Box>
              {/* STEP BUTTONS ZONE */}
              {tablet && initCourse && (
                <Box
                  style={{
                    borderTop: '1px solid #eee',
                    padding: '8px 0',
                    flexShrink: 0,
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                  }}>
                  {doneStatus.length > 0 &&
                    (doneStatus[activeContent].status ===
                      ContentStatus.DoneApproved ||
                      doneStatus[activeContent].status ===
                        ContentStatus.DoneFailed) && (
                      <StepButtons
                        changeStep={(step) => moveContent(step)}
                        index={activeContent}
                        max={contents.length}
                        atEnding={{
                          button: 'Firmar',
                          action: () => setPopupFinish(true),
                          disabled: doneStatus.some(
                            (done) =>
                              done.status === ContentStatus.DoneFailed ||
                              done.status === ContentStatus.Undone,
                          ),
                        }}
                      />
                    )}
                </Box>
              )}
              {tablet ? (
                <Box
                  style={{
                    borderTop: '1px solid #ddd',
                    padding: '8px 12px',
                    flexShrink: 0,
                    backgroundColor: '#fff',
                  }}>
                  <Grid container spacing={1}>
                    {initCourse && (
                      <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary">
                          {activeContent + 1}/{contents.length}
                        </Typography>
                      </Grid>
                    )}
                    {initCourse && (
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="medium"
                          onClick={() => setShowContentList(!showContentList)}>
                          <Trans>Contenidos</Trans>
                        </Button>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="medium"
                        onClick={() => setPopupOut(true)}>
                        <Trans>Salir</Trans>
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <></>
              )}
            </Paper>
          </Box>
          <SignatureDialog
            disableEscape={false}
            openDialog={popupFinish}
            onCloseDialog={() => setPopupFinish(false)}
            dialogTitle={i18n2._('Confirmar operación')}
            user={props.data.cwid}
            submit={(values, {resetForm}) => submit(values, resetForm)}
            snackbarState={courseFinished}
            onCloseSnackbar={() => {
              if (courseFinished.approved) {
                dispatch({
                  type: REMOVE_NOTIFICATION,
                  payload: {
                    id_instance: props.data.iD_Instance,
                    id_course: props.data.iD_Course,
                  },
                });
                setRedirect(true);
              } else {
                setCourseFinished({
                  open: false,
                  score: 0,
                  approved: false,
                  message: '',
                });
              }
            }}
          />
          <Dialog
            open={poupOut}
            onClose={() => setPopupOut(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
              <Trans>Abandonar curso</Trans>
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" align="center">
                <Trans>¿Está seguro que desea salir del curso?</Trans>
              </Typography>
              <Typography variant="subtitle2" align="center">
                <Trans>Se guardará el intento con puntaje 0.</Trans>
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setRedirect(true)}>
                <Trans>Confirmar</Trans>
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default Tablet;
